import { createApp } from 'vue/dist/vue.esm-bundler';
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel';
import moment from 'moment';

const useReviewData = (store = '') => {
  const reviews = ref([]);
  const showSpinner = ref(true);
  const storeRate = ref(0);
  const storeRatePercentage = ref(0);
  const isDecimal = ref(false);
  const firstDigit = ref(0);

  const fetchData = async () => {
    try {
      const api = store !== ''
          ? `https://api.feefo.com/api/10/reviews/all?merchant_identifier=store-first-management&tags=store:${store}`
          : 'https://api.feefo.com/api/10/reviews/all?merchant_identifier=store-first-management';

      const reviewsResponse = await axios.get(api);
      reviews.value = reviewsResponse.data.reviews.map((review) => ({
        rating: review.products ? review.products[0].rating.rating : review.service.rating.rating,
        desc: review.products ? review.products[0].review : review.service.review,
        customer: review.customer ? review.customer.display_name : 'Anonymous',
        updated_at: review.last_updated_date
      }));
      showSpinner.value = false;

      // Fetch summary
      const apiSummary = store !== ''
          ? `https://api.feefo.com/api/10/reviews/summary/all?merchant_identifier=store-first-management-group&tags=store:${store}`
          : 'https://api.feefo.com/api/10/reviews/summary/all?merchant_identifier=store-first-management-group';

      const summaryResponse = await axios.get(apiSummary);
      storeRate.value = summaryResponse.data.rating.rating;
      storeRatePercentage.value = Math.round((storeRate.value / 5) * 100);

      const formattedRate = Math.floor(storeRate.value * 2) / 2;
      firstDigit.value = Math.floor(storeRate.value);
      isDecimal.value = formattedRate % 1 !== 0;
    } catch (error) {
      showSpinner.value = false;
    }
  };

  return {
    reviews,
    showSpinner,
    storeRate,
    storeRatePercentage,
    isDecimal,
    firstDigit,
    fetchData
  };
};

const reviewCards = () => {
  const list = document.querySelector('[js-card-reviews]');

  if (!list) {
    return;
  }

  const store = list.getAttribute('js-card-reviews');

  const app = createApp({
    template: list.innerHTML,
    components: {
      Carousel,
      Slide,
      Navigation,
      Pagination
    },
    delimiters: ['${', '}'],
    setup() {
      const carousel = ref(null);
      const {
        reviews,
        showSpinner,
        storeRate,
        storeRatePercentage,
        isDecimal,
        firstDigit,
        fetchData
      } = useReviewData(store);

      const showCarousel = computed(() =>
          !showSpinner.value && reviews.value.length > 0
      );

      const next = () => {
        carousel.value?.next();
      };

      const prev = () => {
        carousel.value?.prev();
      };

      const truncate = (value) => {
        if (value && value.length > 80) {
          return `${value.substring(0, 77)}...`;
        }
        return value;
      };

      const formatDate = (date) => {
        return moment(date).format('DD MMM YYYY');
      };

      onMounted(() => {
        fetchData();
      });

      return {
        reviews,
        showSpinner,
        storeRate,
        storeRatePercentage,
        isDecimal,
        firstDigit,
        showCarousel,
        carousel,
        store,
        next,
        prev,
        truncate,
        formatDate
      };
    }
  });

  app.mount(list);
};

export default reviewCards;
